<template>
  <aside class="filters dealers">
    <form
      action
      @submit.prevent="function () {}"
      class="car-filters-wrap"
      id="car-filters"
    >
      <div class="filters-top-wrap">
        <div class="filters-car-brand-wrap">
          <!-- <FilterBrands :brands="d.brands" :filters="filters" /> -->
<!--          <div v-if="!$device.tablet()" class="select-car-wrapper">
            <div class="select-car-type">
              <other-filter
                      title="Hverju ertu að leita að?"
                      :data="allFiltersData"
                      :filters="filters"
                      :all-filters-names="allFiltersNames"
                      :filter_name="'all_filters'"
                      :url="'/new-cars/auka'"
                      @dropdown-data-from-url="dropdownDataFromUrl"
                      @selectedBrands="toggleFilterFlag"
              />
            </div>
          </div>-->

          <FilterCarBodyTypes
            :filters="filters"/>

          <div class="filters-car-selects">
            <div v-if="$device.tablet()" class="select-car-wrapper">
              <div class="select-car-type">
                <other-filter
                        title="Hverju ertu að leita að?"
                        :data="allFiltersData"
                        :filters="filters"
                        :all-filters-names="allFiltersNames"
                        :filter_name="'all_filters'"
                        :url="'/new-cars/auka'"
                        @dropdown-data-from-url="dropdownDataFromUrl"
                        @selectedBrands="toggleFilterFlag"
                />
              </div>
            </div>

            <!-- Select 1 -->
            <div class="select-car-wrapper">
              <div class="select-car-type">
                <other-filter
                  :title="getBrandFilterTitle"
                  :data="otherSliderRefactor(d.brands, 'brand')"
                  :filters="filters"
                  :filter_name="'brands'"
                  @selectedBrands="toggleFilterFlag"
                />
              </div>
            </div>

            <!-- Select 2 -->
            <transition name="toggle" :duration="100">
              <div
                class="select-car-type"
                style="padding-top: 0px"
                v-if="isSetFilterBrand"
              >
                <other-filter
                  :title="'Alla gerðir'"
                  :data="otherSliderRefactor(d.brands_model, 'model_class')"
                  :filters="filters"
                  :filter_name="'models_id'"
                />
              </div>
            </transition>

            <!-- Select 3 -->
            <div style="padding-top: 0px" class="select-car-type">
              <other-filter
                :title="'Bílaumboð'"
                :data="d.company"
                :filters="filters"
                :filter_name="'company'"
              />

              <div
                v-if="$device.ios()"
                class="hide-media-table"
                style="font-size: 14px; color: #0b58a2"
              >
                <div>Version: {{ $store.state.app_version }}</div>
                <div>Host: {{ $store.state.api }}</div>
              </div>
            </div>

            <div class="hr hide-media-table show-media-mobile"></div>
            <!-- Range slider -->
            <transition name="toggle" mode="out-in" :duration="300">
              <FormUiSliderPreloader v-if="!$store.state.dataCarsLoadedFlag" />
              <div class="filters-range-wrap" v-else>
                <form-ui-slider
                  :title="'Verð'"
                  :name="'verd'"
                  :filters="filters"
                  :params="verd_params"
                  :unit="'kr.'"
                />
              </div>
            </transition>
          </div>
        </div>
        <hr class="hr" />
      </div>
      <div class="filters-bottom-wrap">
        <!-- Filters checkbox 1 -->
        <!-- <transition name="toggle" mode="out-in" :duration="300">
         <div
           class="checkbox-filters-wrap checkbox-filters-wrap--preloader"
           v-if="!$store.state.dataCarsLoadedFlag"
         >
           <label
             v-for="(name, index) in typesOfFuel"
             :for="name + index"
             :key="index"
             class="checkbox-filter-label"
           >
             <input :id="name + index" type="checkbox" />
             <span class="checkmark"></span>
             <span class="checkbox-filter-hint">{{ name }}</span>
             <span class="checkbox-filter-hint-count shine-short">0</span>
           </label>
         </div> -->
          <div class="checkbox-filters-wrap" v-if="getFuelType">
            <label
              v-for="(type, index) in getFuelType"
              :for="type.subname"
              :key="index"
              class="checkbox-filter-label"
            >
              <input
                v-model="filters.fuel_type"
                :value="type.id"
                :id="type.subname"
                type="checkbox"
              />
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">{{ type.name }}</span>
              <span class="checkbox-filter-hint-count">{{ type.co }}</span>
            </label>
            <!-- <label class="checkbox-filter-label" v-if="getShowFuelFroup">
              <input v-model="fuel_group" value="0" type="checkbox" />
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">Nýorka</span>
            </label> -->
          </div>
        <!-- </transition> -->
        <hr class="hr mobile-filters-hide" />
        <hr class="hr mobile-filters-hr" />
        <!-- Filters checkbox 2 -->
        <!--<transition name="toggle" mode="out-in" :duration="300">
          <div
            class="checkbox-filters-wrap checkbox-filters-wrap--preloader"
            v-if="!$store.state.dataCarsLoadedFlag"
          >
            <label
              v-for="(name, index) in typesOfTransmission"
              :for="name"
              :key="index"
              class="checkbox-filter-label"
            >
              <input type="checkbox" :id="name" :value="index" />
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">{{ name }}</span>
              <span class="checkbox-filter-hint-count shine-short">0</span>
            </label>
          </div>-->
          <div class="checkbox-filters-wrap">
            <label
              v-for="(gi, index) in getTransmission"
              :for="gi.name.toLocaleLowerCase()"
              :key="index"
              class="checkbox-filter-label"
            >
              <input
                v-model="filters.transmision"
                type="checkbox"
                :id="gi.name.toLocaleLowerCase()"
                :value="gi.id"
              />
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">{{ gi.name }}</span>
              <span class="checkbox-filter-hint-count">{{ gi.co }}</span>
            </label>
          </div>
        <!-- </transition> -->
        <hr class="hr mobile-filters-hr" />
        <hr class="hr desctop-filters-hr" />
        <!-- Filters checkbox 3 -->
        <div class="checkbox-filters-wrap tilbod">
          <label for="sale" class="checkbox-filter-label">
            <input type="checkbox" v-model="filters.discount" id="sale" />
            <span class="checkmark"></span>
            <span class="checkbox-filter-hint">Tilboðsbílar</span>
            <img src="/i/sale.png" alt width="21px" height="16px" />
          </label>
        </div>

<!--        <transition name="toggle" mode="out-in" :duration="300">
          <FormUiSliderPreloader :title="'Drægni'" v-if="!$store.state.dataCarsLoadedFlag" />
          <div class="filters-range-wrap" v-else>
            <form-ui-slider
                class="big-unit50"
                :title="'Drægni'"
                :name="'affinity'"
                :filters="filters"
                :params="getAffinity"
                :unit="'km.'"
            />
          </div>
        </transition>-->

<!--          <FormUiSliderPreloader :title="'Dráttargeta'" v-if="!$store.state.dataCarsLoadedFlag" />
          <div class="filters-range-wrap" v-else>
            <form-ui-slider
                class="big-unit"
                :title="'Dráttargeta'"
                :name="'towing_capacity'"
                :filters="filters"
                :params="getCapacity"
                :unit="'kg.'"
            />
          </div>-->

        <template v-for="(item) in asideList">
          <template v-if="item.type === 'dropDown'">
            <div class="select-car-type">
              <other-filter
                  :title="item.title"
                  :data="getDataFromDropDown(item.lib)"
                  :filters="filters"
                  :filter_name="item.name"
              />
            </div>
          </template>

          <template v-if="item.type === 'slider'">
            <transition name="toggle">
              <FormUiSliderPreloader :title="item.title" v-if="!$store.state.dataCarsLoadedFlag"/>
              <div class="filters-range-wrap" v-else>
                <form-ui-slider
                    class="big-unit"
                    :title="item.title"
                    :name="item.name"
                    :filters="filters"
                    :params="getStartParams(item.name)"
                    :unit="item.unit"
                />
              </div>
            </transition>

          </template>
        </template>

<!--        <transition name="toggle">
          <FormUiSliderPreloader :title="'Slagrými'" v-if="!$store.state.dataCarsLoadedFlag"/>
          <div class="filters-range-wrap" v-else>
            <form-ui-slider
                class="big-unit"
                :title="'Stærð rafhlöðu'"
                :name="'battery_capacity'"
                :filters="filters"
                :params="getEngine"
                :unit="'cc.'"
            />
          </div>
        </transition>-->

<!--        <transition name="toggle">
          <FormUiSliderPreloader :title="'Slagrými'" v-if="!$store.state.dataCarsLoadedFlag"/>
          <div class="filters-range-wrap" v-else>
            <form-ui-slider
                class="big-unit"
                :title="'Slagrými'"
                :name="'engine'"
                :filters="filters"
                :params="getEngine"
                :unit="'cc.'"
            />
          </div>
        </transition>-->


<!--        <transition name="toggle" mode="out-in">
          <FormUiSliderPreloader :title="'Hestöfl'" v-if="!$store.state.dataCarsLoadedFlag"/>
          <div class="filters-range-wrap" v-else>
            <form-ui-slider
                class="big-unit"
                :title="'Hestöfl'"
                :name="'horse_power'"
                :filters="filters"
                :params="getHorsePower"
            />
          </div>
        </transition>-->


<!--        <transition name="toggle" mode="out-in" :duration="300">
          <FormUiSliderPreloader :title="'co2'" v-if="!$store.state.dataCarsLoadedFlag"/>
          <div class="filters-range-wrap" v-else>
            <form-ui-slider
                class="big-unit"
                :title="'co2'"
                :name="'co2'"
                :filters="filters"
                :params="getCo2"
            />
          </div>
        </transition>-->


<!--        <div class="select-car-type">
          <other-filter
            :title="'Stærð og gerð'"
            :data="gatCats"
            :filters="filters"
            :filter_name="'cat'"
          />
        </div>-->

<!--        <div class="select-car-type">
          <other-filter
            :title="'Drif'"
            :data="d.drif"
            :filters="filters"
            :filter_name="'drif'"
          />
        </div>-->
<!--        <div class="select-car-type">
          <other-filter
            :title="'Aukahlutir'"
            :data="lib.aukahlutir"
            :filters="filters"
            :filter_name="'aukahlutir'"
          />
        </div>-->
        <div class="filters-mobile-controls-">
          <!--                    <button class="filters-mobile-extra-btn" type="button">-->
          <!--                        <span>+ Opna</span> ítarleg leit-->
          <!--                    </button>-->
          <div
            ref="fm_res_wrap"
            :class="[
              'filters-mobile-results-wrap',
              { op: $store.state.scrollTop < 598 },
            ]"
          >
<!--            <ResetFilter
              v-if="$store.state.selected_filters_count > 0"
              class="filters-mobile-results-clear-btn"
              >hreinsa síu
            </ResetFilter>-->

<!--            <scroll-to-res-btn />-->
          </div>
        </div>
      </div>
      <div class="aside_div_bottom" :style="{height: `${$device.android() ? 150 : 80}px`}"></div>
    </form>
  </aside>
</template>

<script>
import FilterCarBodyTypes from "@/components/Filters/СarBodyTypes";
import OtherFilter from "../OtherFilter.vue";
import FormUiSliderPreloader from "@/components/FormUiSliderPreloader";
import FormUiSlider from "../FormUiSlider.vue";
import ResetFilter from "../ResetFilter.vue";
import BASE_URL from '@/helpers/getBaseUrl';
import _ from "lodash"

import {mapGetters, mapState} from "vuex";
import axios from "axios";

export default {
  components: {
    FilterCarBodyTypes,
    FormUiSlider,
    FormUiSliderPreloader,
    OtherFilter,
    ResetFilter,
  },
  data: () => ({
    count: 0,
    init: true,
    owl: null,
    verd_params: null,
    fuel_group: null,
    typesOfFuel: [
      "Bensín",
      "Dísel",
      "Tvinnbílar",
      "Metan",
      "Rafmagn",
      "Tengiltvinn (PHEV)",
      "Vetni",
    ],
    typesOfTransmission: ["Sjálfskipting", "Beinskipting"],
    fuel_group_id: [2, 100, 3, 101],
    dataFromUrl: [],
    allFiltersNames: ['brands', 'company', 'fuel_type', 'transmision', 'cat', 'drif', 'aukahlutir'],
    allFiltersData: []
  }),
  methods: {
    async getAllFiltersData() {
      let all = []

      if (this.allFiltersData.length) return
      if (Object.keys(this.d).length !== 0) {
        const brands = this.otherSliderRefactor(this.d.brands, 'brand')
        axios.post(`${BASE_URL()}/api/new-cars/get?access-token=${this.accessToken}`,
          {
            filters: {brands: brands.map(brand => brand.id)},
            sort: this.filters.sort,
            total_load: 0,
          }
        )
        .then(({ data }) => {
          let brandsWithModels = this.otherSliderRefactor(data.brands_model, 'model_class', brands)
          brandsWithModels.forEach(a => {
            if (a.model_class) a.filter_name = 'models_id'
          })

          all = all.concat(
            this.collectAllFiltersItem(brandsWithModels, 'brands', 'Allir framleiðendur'),
            this.collectAllFiltersItem(this.d.company, 'company', 'Bílaumboð'),
            this.collectAllFiltersItem(this.getFuelType, 'fuel_type', 'Eldsneyti'),
            this.collectAllFiltersItem(this.getTransmission, 'transmision', 'Skipting'),
            this.collectAllFiltersItem(this.gatCats, 'cat', 'Stærð og gerð'),
            this.collectAllFiltersItem(this.d.drif, 'drif', 'Drif'),
            this.collectAllFiltersItem(this.lib.aukahlutir, 'aukahlutir', 'Aukahlutir'),
          )

          this.allFiltersData = all
        })
      }},
    resetFilter: function () {
      this.filters.fuel_type = [];
    },
    toggleFilterFlag: function (data) {
      this.$store.state.onFilterBrandsFlag = data;
    },
    otherSliderRefactor: function (arr, name, brands = []) {
      for (let k in arr) {
        if (arr[k].disable && name === 'model_class' && brands.length) {
          arr[k] = brands.find(brand => brand.brand === arr[k].model_class)
        } else if (arr[k][name]) {
          arr[k].name = arr[k][name];
        }
      }
      return arr;
    },
    updExtra: function () {
      window.extraType = false;
    },
    isBrand: function (id) {
      return this.filters.brands[id];
    },
    getOtheSelected: function (filter, other) {
      let res = [];
      for (let k in other) {
        let item = other[k];
        if (filter && filter.indexOf(item.id) >= 0) {
          res.push(item);
        }
      }
      return res;
    },

    getStartParams(paramKey) {
      const startParam = this.newCarsStartParams[paramKey];
      let curFilter = this.filters[paramKey];
      let min = startParam.min;
      let max = startParam.max;
      if(curFilter.length > 0){
        if(curFilter.length === 1){
          min = parseInt(curFilter[0]);
        }else{
          min = parseInt(curFilter[0]);
          max = parseInt(curFilter[1]);
        }
      }
      if(isNaN(min)){
        min = startParam.min;
      }
      if(isNaN(max)){
        max = startParam.max;
      }
      let start = [min,max];


      /*
            if (curFilter && curFilter.length > 0){
              if(this.filters.affinity[0]){
                start[0] = curFilter[0];
              }else{
                curFilter[0] = startParam.min;
              }

              if(curFilter[1]){
                start[1] = curFilter[1];
              }else{
                curFilter[1] = startParam.max;
              }
            }
      */
      return {
        min: startParam.min,
        max: startParam.max,
        start: start,
        step: startParam.step
      };
    },
    dropdownDataFromUrl(data) {
      this.dataFromUrl = data
    },
    collectAllFiltersItem(data, filterName, groupLabel) {
      let newData = []
      if (data && data.length) {
        newData = JSON.parse(JSON.stringify(data))
        newData.forEach(item => {
          if (!item.model_class) item.filter_name = filterName
          else item.name = item.model_class
        })
        if (filterName === 'brands') {
          newData = _.orderBy(newData, 'brand')
        }
        newData.unshift({ name: groupLabel, isLabel: true })

        return newData
      }
    },
    getDataFromDropDown(key){
      return this.lib[key];
    },
  },
  mounted() {
    document.body.classList.add("js-show-filters");

    if(this.filters && this.filters.verd){
      if (this.filters.verd[0] == null && this.filters.verd[1]) {
        this.filters.verd[0] = 0;
      }
      if (this.filters.verd[1]) {
        this.filters.verd[1] = parseInt(this.filters.verd[1]);
      }
    }
  },
  beforeDestroy() {
    document.body.classList.remove("js-show-filters");
  },
  computed: {
    ...mapState({
      dataPage: (state) => state.dealers.page,
      accessToken: (state) => state.access_token,
    }),
    ...mapGetters({lib:"LIB"}),
    ...mapState('newCars', {
      newCarsStartParams:  'startParams',
      asideList:  'asideList',
    }),
    /*getAffinity(){
      const startAffinity = this.newCarsStartParams.affinity;
      let start = [startAffinity.min,startAffinity.max];

      if (this.filters.affinity && this.filters.affinity.length > 0){
        if(this.filters.affinity[0]){
          start[0] = this.filters.affinity[0];
        }else{
          this.filters.affinity[0] = startAffinity.min;
        }

        if(this.filters.affinity[1]){
          start[1] = this.filters.affinity[1];
        }else{
          this.filters.affinity[1] = startAffinity.max;
        }
      }

      return {
        min:startAffinity.min,
        max:startAffinity.max,
        start: start,
        step:10
      };
    },*/
   /* getCapacity(){
      const startCapacity = this.newCarsStartParams.towing_capacity;
      let start = [startCapacity.min,startCapacity.max];

      if (this.filters.towing_capacity && this.filters.towing_capacity.length > 0){
        if(this.filters.towing_capacity[0]){
          start[0] = this.filters.towing_capacity[0];
        }else{
          this.filters.towing_capacity[0] = startCapacity.min;
        }

        if(this.filters.towing_capacity[1]){
          start[1] = this.filters.towing_capacity[1];
        }else{
          this.filters.towing_capacity[1] = startCapacity.max;
        }
      }

      return {
        min:startCapacity.min,
        max:startCapacity.max,
        start: start,
        step:10
      };
    },
    getEngine() {
      return this.getStartParams('engine')
    },
    getHorsePower() {
      return this.getStartParams('horse_power')
    },
    getCo2() {
      return this.getStartParams('co2')
    },*/
    d() {
      return this.dataPage;
    },
    /*gatCats(){
      return this.lib.cat_new_cars;
    },*/
    dataCarsLoaded: function () {
      return this.$store.state.dataCarsLoadedFlag;
    },
    filterOn() {
      return this.$store.getters.onFilterBrandsFlag;
    },
    getFuelType() {
      return this.d.fuel_type && this.d.fuel_type.filter(type => type.id);
    },
    getShowFuelFroup: function () {
      let fuel_group = this.fuel_group_id;

      return this.getFuelType.some(function (data) {
        return fuel_group.indexOf(parseInt(data.id)) >= 0;
      });
    },
    getTransmission: function () {
      return this.d.transmision && this.d.transmision.filter(function (data) {
        data.for = data.name.toLocaleLowerCase();
        return data;
      });
    },
    isSetFilterBrand(){
      return this.filters && this.filters.brands && this.filters.brands.length > 0;
    },
    getBrandFilterTitle(){
      return this.isSetFilterBrand
          ? 'Veldu framleiðenda'
          : 'Allir framleiðendur'
    },
  },
  watch: {
    /*
            "filters.fuel_type": function (n) {
                let fuel_group = this.fuel_group_id; //[2, 100, 3, 101];
                let co = 0;

                for (let k in n) {
                    if (fuel_group.indexOf(parseInt(n[k])) >= 0) {
                        co++;
                    }
                }
                if (co < 4) {
                    this.fuel_group = false;
                }
            },*/
    fuel_group() {
      if (this.fuel_group == true) {
        this.filters.fuel_type = this.fuel_group_id;
      }
    },
    d: {
      immediate: true,
      handler() {
        let res = [];
        if (this.d.price_f) {
          res.min = parseInt(this.d.price_f.mi);
          res.max = parseInt(this.d.price_f.ma);
        }
        res.start = [];
        if (this.filters.verd && this.filters.verd.length > 0) {
          res.start = this.filters.verd;
        } else {
          res.start[0] = res.min;
          res.start[1] = res.max;
        }

        if(!res.start[0] && !res.start[1]){
          res.start[0] = 0;
          res.start[1] = 20000000;
        }

        if(!res.min && !res.max){
          res.min = res.start[0];
          res.max = res.start[1];
        }

        res.step = 500000;
        this.verd_params = res;

        this.getAllFiltersData()
      },
      deep: true,
    },
  },
  props: [/* "d", */ "filters"],
};
</script>
